export const copy = value => value === undefined ? undefined : JSON.parse(JSON.stringify(value))
export const same = (left, right) => JSON.stringify(left) === JSON.stringify(right)

// Fill order in the second position window: one request per form area,
// starting with area 2, then 3, the abstract on its own, 4, and back to 1.
// Location and the max-salary number are deliberately left to the recruiter.
export const POSITION_ASSISTANT_AREAS = [
  { id: 'area-2', keys: ['min_seniority', 'max_seniority', 'job_title_ids'] },
  { id: 'area-3', keys: ['salary_expectations_comment', 'skill_ids', 'is_discrete', 'work_entails'] },
  { id: 'abstract', keys: ['abstract'] },
  { id: 'area-4', keys: ['message', 'contact_email', 'contact_phones'] },
  { id: 'area-1', keys: ['company_position_id', 'priority_warning'] }
]
const SENIORITY = ['min_seniority', 'max_seniority']

// Save units of an area, in its order: the seniority bounds are one unit.
export function assistantSaveUnits (keys) {
  const units = []
  for (const key of keys) {
    if (SENIORITY.includes(key)) {
      if (!units.some(unit => unit === SENIORITY)) units.push(SENIORITY)
    } else units.push([key])
  }
  return units
}

// Decimal columns come back serialized as strings ("28000.0"), so numbers compare by value.
export const savedEquals = (saved, expected) => {
  if (typeof expected === 'number') return saved !== null && saved !== '' && Number(saved) === expected
  return String(saved == null ? '' : saved) === String(expected == null ? '' : expected)
}

export function newPositionAssistantSession () {
  return {
    used: false,
    ratings: { performance: 0, usefulness: 0 },
    feedback: '',
    ratingSent: false
  }
}

// Collections are additive: existing requirements and their settings stay intact.
export async function applyPositionSuggestion (api, positionId, companyId, key, value) {
  if (key === 'seniority_range') {
    await api.updatePosition({ position_id: positionId, ...value, active_at: new Date() })
    const saved = await api.getPosition({ id: positionId })
    for (const field of Object.keys(value)) {
      if (!savedEquals(saved[field], value[field])) throw new Error('Value was not saved')
    }
    return saved
  } else if (key === 'skill_ids') {
    const current = await api.getPositionSkills({ position_id: positionId, current_company_id: companyId })
    for (const id of value || []) {
      if (!current.some(item => (item.skill_id || item.skill.id) === id)) {
        await api.postPositionSkill({ position_id: positionId, current_company_id: companyId, skill_id: id, importance: 2, is_tagged: true, min_experience: 0 })
      }
    }
    const saved = await api.getPositionSkills({ position_id: positionId, current_company_id: companyId })
    if ((value || []).some(id => !saved.some(item => (item.skill_id || item.skill.id) === id))) throw new Error('Value was not saved')
  } else if (key === 'job_title_ids') {
    const current = await api.getPositionJobTitle({ position_id: positionId })
    for (const id of value || []) {
      if (!current.some(item => item.job_title.id === id)) {
        await api.postPositionJobTitle({ position_id: positionId, job_title_id: id })
      }
    }
    const saved = await api.getPositionJobTitle({ position_id: positionId })
    if ((value || []).some(id => !saved.some(item => item.job_title.id === id))) throw new Error('Value was not saved')
    return saved
  } else if (['work_entails', 'contact_email'].includes(key)) {
    const content = key === 'work_entails' ? (value || '').split(/\r?\n/).filter(line => line.trim()).join('@@@') : (value || '')
    await api.postText({ current_type: 'Position',
      current_resource_id: positionId,
      designator: key,
      content })
    const saved = await api.getResourceTexts({ current_type: 'Position', current_resource_id: positionId })
    if (!saved.some(text => text.designator === key && text.content === content)) throw new Error('Value was not saved')
  } else {
    await api.updatePosition({ position_id: positionId, [key]: value, active_at: new Date() })
    // The legacy update endpoint returns 204 even for some validation failures.
    const saved = await api.getPosition({ id: positionId })
    if (!savedEquals(saved[key], value)) throw new Error('Value was not saved')
    return saved
  }
}
